/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {BaseComponent, Dialog_Builder} from "@intuitionrobotics/thunderstorm/frontend";
import {DB_Patient} from "@app/app-shared/patient";
import {ICONS} from "@res/icons";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import * as React from "react";
import {MedicationReminderDialog} from "./MedicationReminderDialog";
import {RemindersModule} from "@modules/RemindersModule";

type Props = {
    patient: DB_Patient;
}

type State = {}

export class AddMedicationReminderButton
    extends BaseComponent<Props, State> {

    render() {
        if (!RemindersModule.assertUserCanEditReminders(this.props.patient))
            return <></>;

        return (
            <div className={`ll_h_c`} style={{justifyContent: "space-between", height: "1.2em", marginRight: 30}}>
                {
                    <div
                        onClick={() => {
                            new Dialog_Builder(
                                <MedicationReminderDialog patient={this.props.patient}/>
                            ).setAllowIndirectClosing(false)
                                .show()
                        }}
                        style={{
                            alignItems: "center",
                            display: "flex",
                            backgroundColor: COLORS.primary_blue,
                            borderRadius: 4,
                            cursor: "pointer",
                            minHeight: 40,
                            padding: "0 10px",
                            textAlign: "center"
                        }}
                    >
                        {ICONS.bell(COLORS.white, 22)}
                        {FONTS.medium_16_white("Add medication reminder", {marginLeft: 5})}
                    </div>
                }
            </div>
        );
    };
}
